import { call, put, takeLatest } from "redux-saga/effects";
import { push } from "react-router-redux";
import swal from "sweetalert";
import { eadApi } from "services/ead";

import {
  Creators as ReasonsActions,
  Types as ReasonsTypes,
} from "store/ducks/reasons";

function* getReasonRequest(action) {
  try {
    const { id } = action.payload;
    const url = `documents/reject-reasons/${id}`;
    const response = yield call(eadApi.get, url);

    yield put(ReasonsActions.getReasonSuccess(response.data));
  } catch (error) {
    yield put(ReasonsActions.getReasonFailure());
  }
}

function* getReasonsRequest() {
  try {
    const url = `documents/reject-reasons`;
    const response = yield call(eadApi.get, url);

    yield put(ReasonsActions.getReasonsSuccess(response.data));
  } catch (error) {
    yield put(ReasonsActions.getReasonsFailure());
  }
}

function* createReasonRequest(action) {
  try {
    const { data } = action.payload;
    const url = "documents/reject-reasons";
    yield call(eadApi.post, url, data);

    yield put(push("/reasons/list"));
    yield call(swal, "Criada", "Razão criada com sucesso!", "success");
    yield put(ReasonsActions.createReasonSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao criar",
      "Não foi possível criar a razão.",
      "error"
    );
    yield put(ReasonsActions.createReasonFailure());
  }
}

function* updateReasonRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `documents/reject-reasons/${id}`;
    yield call(eadApi.put, url, data);

    yield put(push("/reasons/list"));
    yield call(swal, "Atualizada", "Razão atualizada com sucesso!", "success");
    yield put(ReasonsActions.updateReasonSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao atualizar",
      "Não foi possível atualizar a razão.",
      "error"
    );
    yield put(ReasonsActions.updateReasonFailure());
  }
}

export default function* saga() {
  yield takeLatest(ReasonsTypes.GET_REQUEST, getReasonRequest);
  yield takeLatest(ReasonsTypes.GET_LIST_REQUEST, getReasonsRequest);
  yield takeLatest(ReasonsTypes.CREATE_REQUEST, createReasonRequest);
  yield takeLatest(ReasonsTypes.UPDATE_REQUEST, updateReasonRequest);
}
